module.exports = __webpack_public_path__ + "img/如何新建导图.60f13ff3.gif";